import React from "react";
import "./Footer.css";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <h2>Contact Us</h2>

        <p>
          Email:{" "}
          <a href="mailto:omkarabrasives@gmail.com">
            omkarabrasives@gmail.com
          </a>
        </p>

        <p>
          Phone:{" "}
          <a href="tel:+917619335665">
            +91 7619 335665
          </a>
        </p>

        <p>
          Address: S-9 Ittina Deva Apartment, Opposite Hotel Guest Line,
          Raghavendra Nagar, Attibele Industrial Area,
          Anekal Taluk, Bangalore – 562107
        </p>
      </div>

      <div className="footer-bottom">
        <p>© 2025 Omkar Abrasives. All rights reserved.</p>
      </div>
    </footer>
  );
}
